/* gn-cart-qty-queue (2026-10-15)
 * Fixes: rapid taps on the cart +/- links lose taps. The links carry a target
 * quantity baked in at render time, so 3 fast taps from 2 all send "3".
 * Design (lessons from the reverted gn-cart-qty-guard, 2026-09-22):
 *  - ONE cart write in flight at a time, across all lines (no out-of-order replies).
 *  - Taps made while a write is in flight are folded into the next write.
 *  - A typed quantity replaces any queued taps for that line.
 *  - Nothing is ever sent on pagehide/unload.
 *  - The drawer is repainted ONCE, from the server reply of the LAST write.
 *  - /cart reloads only after the LAST write has been answered.
 *  - Checkout pressed while writes are pending waits for them, then continues.
 */
(function () {
  if (window.__gnQtyQueue) return;
  window.__gnQtyQueue = true;

  var intended = {};     // lineKey -> quantity the shopper asked for
  var queue = [];        // lineKeys waiting, in tap order
  var busy = false;
  var pendingCheckout = null;
  var gen = 0;           // bumped on back/forward restore: a frozen run must not resume
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var isCartPage = function () {
    return window.themeVariables && themeVariables.settings && themeVariables.settings.pageType === 'cart';
  };

  function renderedQty(host) {
    var input = host.querySelector('input[data-line-key]');
    if (!input) return null;
    var v = parseInt(input.defaultValue || input.getAttribute('value'), 10);
    return isNaN(v) ? null : v;
  }

  function enqueue(key, qty, host) {
    intended[key] = Math.max(0, qty);
    var input = host && host.querySelector('input[data-line-key]');
    if (input) input.value = intended[key];
    if (queue.indexOf(key) === -1) queue.push(key);
    if (!busy) run();
  }

  function fire(name, detail, target) {
    (target || document.documentElement).dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
  }

  // While writes are pending the total on screen is not final: show the
  // Checkout button(s) as busy (spinner, still clickable; the submit guard waits).
  // Prices that are not final yet are faded (2026-10-15, owner: "fade the Checkout
  // price and the cart total while an update is running").
  var fadeCss = document.createElement('style');
  fadeCss.textContent = '.gn-price-updating{opacity:.3!important;transition:opacity .15s}';
  document.head.appendChild(fadeCss);
  function priceEls() {
    var els = [].slice.call(document.querySelectorAll('.cart-drawer__button-price, main td.text-end'));
    // /cart summary: the amount span sits right after its "Total:" / "Subtotal:" label span.
    document.querySelectorAll('main .h-stack > span + span').forEach(function (s) {
      if (/^\s*(sub)?total\s*:?\s*$/i.test(s.previousElementSibling.textContent)) els.push(s);
    });
    return els;
  }
  function markBusy(on) {
    document.querySelectorAll('button[name="checkout"]').forEach(function (b) {
      if (on) { b.setAttribute('aria-busy', 'true'); b.setAttribute('data-gn-busy', ''); }
      else if (b.hasAttribute('data-gn-busy')) { b.removeAttribute('aria-busy'); b.removeAttribute('data-gn-busy'); }
    });
    if (on) priceEls().forEach(function (el) { el.classList.add('gn-price-updating'); });
  }
  // Fade is lifted only after the repaint has had time to swap in the new price
  // (the repaint replaces the faded nodes; this is the safety net if it doesn't).
  function clearFade(now) {
    var go = function () { if (!busy) document.querySelectorAll('.gn-price-updating').forEach(function (el) { el.classList.remove('gn-price-updating'); }); };
    now ? go() : setTimeout(go, 1500);
  }

  async function run() {
    busy = true;
    var myGen = gen;
    markBusy(true);
    var lastCart = null, lastKey = null, failed = null;
    fire('theme:loading:start');
    try {
      while (queue.length) {
        var key = queue.shift();
        var qty = intended[key];
        var sections = [];
        fire('cart:prepare-bundled-sections', { sections: sections });
        var res = await fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty, sections: sections.join(',') })
        });
        var body = await res.json().catch(function () { return {}; });
        if (myGen !== gen) return; // page was restored from bfcache: the pageshow reset owns state now
        if (!res.ok) { failed = { key: key, description: body.description || 'Could not update the cart.' }; queue.length = 0; break; }
        lastCart = body; lastKey = key;
      }
    } catch (e) {
      if (myGen !== gen) return;
      failed = { key: null, description: 'Could not update the cart.' };
      queue.length = 0;
    }
    fire('theme:loading:end');
    // Next taps start from the server's answer, even if the repaint lags behind.
    intended = {};
    if (lastCart && !failed) lastCart.items.forEach(function (i) { intended[i.key] = i.quantity; });
    busy = false;
    markBusy(false);
    if (!isCartPage()) clearFade();

    if (isCartPage()) { window.location.reload(); return; }

    if (failed) {
      // Repaint every cart view from the server so nothing shows a guess.
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      var host = failed.key && document.querySelector('line-item-quantity input[data-line-key="' + CSS.escape(failed.key) + '"]');
      host = host && host.closest('line-item-quantity');
      if (host) {
        host.parentElement.querySelector('[role="alert"]') && host.parentElement.querySelector('[role="alert"]').remove();
        var p = document.createElement('p');
        p.className = 'h-stack gap-2 justify-center text-xs';
        p.setAttribute('role', 'alert');
        p.textContent = failed.description;
        host.insertAdjacentElement('afterend', p);
      }
      pendingCheckout = null;
      return;
    }

    if (lastCart) {
      var li = document.querySelector('line-item-quantity input[data-line-key="' + CSS.escape(lastKey) + '"]');
      li = li && li.closest('line-item');
      var after = lastCart.items.filter(function (i) { return i.key === lastKey; });
      if (li) fire('line-item:change', { quantity: after.length ? after[0].quantity : 0, cart: lastCart }, li);
      fire('cart:change', { baseEvent: 'line-item:change', cart: lastCart, gnQueue: true });
    }

    if (pendingCheckout) { var go = pendingCheckout; pendingCheckout = null; window.location.href = go; }
  }

  // Any cart change made elsewhere (add to cart, refresh, back-nav) resets what we remember.
  document.addEventListener('cart:change', function (e) {
    if (!(e.detail && e.detail.gnQueue) && !busy) intended = {};
  });
  document.addEventListener('cart:refresh', function () { if (!busy) intended = {}; });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { gen++; busy = false; queue = []; pendingCheckout = null; }
    if (!busy) { intended = {}; markBusy(false); clearFade(true); }
  });

  // +, -, Remove links (capture phase: runs before the theme's own handler).
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('line-item-quantity a[href*="/cart/change"]');
    if (!a) return;
    var host = a.closest('line-item-quantity');
    var url = new URL(a.href, location.origin);
    var key = url.searchParams.get('id');
    var hrefQty = parseInt(url.searchParams.get('quantity'), 10);
    if (!key || isNaN(hrefQty)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var base = renderedQty(host);
    var target;
    if (a.classList.contains('quantity-selector__button') && base !== null) {
      // +/-: the link encodes one step (rendered qty +/- increment); apply that step
      // to what the shopper has already asked for, not to the stale rendered qty.
      var current = intended.hasOwnProperty(key) ? intended[key] : base;
      target = current + (hrefQty - base);
    } else {
      target = hrefQty; // Remove link (absolute 0)
    }
    enqueue(key, target, host);
  }, true);

  // Typed quantity: replaces queued taps for that line.
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('line-item-quantity input[data-line-key]')) return;
    var v = parseInt(input.value, 10);
    if (isNaN(v)) return;
    e.stopImmediatePropagation();
    enqueue(input.getAttribute('data-line-key'), v, input.closest('line-item-quantity'));
  }, true);

  // Checkout while writes are pending: wait for them, then go.
  document.addEventListener('submit', function (e) {
    if (!busy) return;
    var f = e.target;
    var sub = e.submitter;
    var toCheckout = (sub && sub.name === 'checkout') || /\/checkout/.test(f.getAttribute('action') || '') ;
    if (!toCheckout && !/\/cart/.test(f.getAttribute('action') || '')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    pendingCheckout = root + 'checkout';
  }, true);
})();
